/* eslint-disable no-underscore-dangle */
import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
  pageContext?: any
}

interface FlexerProps {
  [key: string]: any
}

interface ComponentProps {
  fields: any
  location?: any
  pageContext?: any
}

const FlexContentHandler: React.FC<FlexContentProps> = ({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
  pageContext,
}) => {
  if (!fields) {
    return null
  }

  const flexers: FlexerProps = {
    [`${prefix}_Flex_Banner`]: loadable(
      () => import('components/flex/Banner/BannerShell')
    ),
    [`${prefix}_Flex_Form`]: loadable(
      () => import('components/flex/Form/FormShell')
    ),
    [`${prefix}_Flex_Text`]: loadable(
      () => import('components/flex/Text/TextShell')
    ),
    [`${prefix}_Flex_Usps`]: loadable(
      () => import('components/flex/Usp/UspShell')
    ),
    [`${prefix}_Flex_Cta`]: loadable(
      () => import('components/flex/Cta/CtaShell')
    ),
    [`${prefix}_Flex_Products`]: loadable(
      () => import('components/flex/Misc/Products')
    ),
    [`${prefix}_Flex_Reviews`]: loadable(
      () => import('components/flex/Reviews/ReviewShell')
    ),
    [`${prefix}_Flex_Gallery`]: loadable(
      () => import('components/flex/Gallery/GalleryShell')
    ),
    [`${prefix}_Flex_Projectdetail`]: loadable(
      () => import('components/flex/ProjectDetail/ProjectDetail')
    ),
    [`${prefix}_Flex_Accordion`]: loadable(
      () => import('components/flex/Misc/Accordion')
    ),
    [`${prefix}_Flex_GoogleMapsInterior`]: loadable(
      () => import('components/flex/Misc/GoogleMapsInterior')
    ),
    [`${prefix}_Flex_SearchEngine`]: loadable(
      () => import('components/flex/Misc/SearchEngine')
    ),
    [`${prefix}_Flex_Video`]: loadable(
      () => import('components/flex/Misc/Video')
    ),
    [`${prefix}_Flex_PostTypes`]: loadable(
      () => import('components/flex/Posts/PostsShell')
    ),
    [`${prefix}_Flex_HighlightedPostTypes`]: loadable(
      () => import('components/flex/Posts/Highlighted/HighlightedShell')
    ),
    [`${prefix}_Flex_LatestPostTypes`]: loadable(
      () => import('components/flex/Posts/Latest/LatestShell')
    ),
    [`${prefix}_Flex_Fragment`]: loadable(
      () => import('components/flex/Fragment')
    ),
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component: React.FC<ComponentProps> =
          flexers[section.fieldGroupName]

        return (
          <Component
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
            fields={section}
            location={location}
            pageContext={pageContext}
          />
        )
      })}
    </>
  )
}

export default FlexContentHandler
